<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">产品管理</div>
        <el-form class="zj-search-form" ref="form" :model="form" :label-width="labelWidth">
          <el-form-item label="产品编号">
            <el-input v-model="Product_Code" placeholder="请输入产品编号"></el-input>
          </el-form-item>
          <el-form-item label="产品名称">
            <el-input v-model="Product_Name" placeholder="请输入产品名称"></el-input>
          </el-form-item>
          <el-form-item class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd">添 加</el-button>
          <el-button size="mini" @click="onbatchDel">删 除</el-button>
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              @selection-change="selectionChange"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column type="selection" width="55"></el-table-column>
              <el-table-column prop="ProductCode" label="产品编号"></el-table-column>
              <el-table-column prop="ProductName" label="产品名称"></el-table-column>
              <el-table-column prop="Description" label="备注">
                <template slot-scope="scope">
                  <el-popover placement="top-start" title="备注" width="250" trigger="hover">
                    <div>{{scope.row.Description}}</div>
                    <span
                      slot="reference"
                    >{{ (scope.row.Description!=null &&scope.row.Description.length>15)?scope.row.Description.substr(0,15)+'...':scope.row.Description }}</span>
                  </el-popover>
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <el-button
                    @click="queryClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                  >查看</el-button>
                  <el-button @click="editClick(scope.$index,scope.row)" type="text" size="small">编辑</el-button>
                  <el-button
                    @click="deleteClick(scope.$index,scope.row)"
                    type="text"
                    size="small"
                  >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5,10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
    <ZjDialog
      :title="dilaogconfig.title"
      :dialogFormVisible="dilaogconfig.dialogFormVisible"
      :width="dilaogconfig.width"
      :height="dilaogconfig.height"
      @clickCancel="handleDialogCancel"
    >
      <ProductInfoPage
        @clickOk="handleDialogOk"
        @clickCancel="handleDialogCancel"
        :Product_Id="SelectedProductId"
        :IsEdit="isEdit"
      ></ProductInfoPage>
    </ZjDialog>
  </div>
</template>

<script>
import utils from "../../../../../../utils";
import WebApis from "../../../apis";
import { showLoading, hideLoading } from "../../../../../../loading";
import ProductInfoPage from "./productinfo.vue";

export default {
  name: "ProductsPage",
  controller: "UI",
  action: "products",
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      Orgs: null,
      Product_Code: "",
      Product_Name: "",
      SelectedProductId: "",
      tableHeight: window.innerHeight - 440,
      dilaogconfig: {
        title: "添加产品",
        dialogFormVisible: false,
        width: "900px",
      },
      multipleSelection: [],
      isEdit: true,
    };
  },
  components: {
    ProductInfoPage,
  },
  props: {
    width: {
      type: String,
      default: "200px",
    },
  },
  created: function () {
    this.init();
  },
  mounted: function () {
    const that = this;
    window.onresize = () => {
      return (() => {
        that.tableHeight = window.innerHeight - 440;
      })();
    };
    this.GetProducts();
    this.logInfo.ActionName = "产品管理查看";
    this.logInfo.LogMessage = "产品管理查看";
    this.logInfo.ModuleName = "权限管理";
    this.logInfo.PageName = "产品管理列表页面";
    this.addOperationLog();
  },
  computed: {},
  methods: {
    // 初始化
    init() {
      return utils.waitAll([() => this.GetProducts()]);
    },
    GetProducts() {
      showLoading(".zj-table-container");

      var Org_Code = this.config.app.org_code;

      let user = this.user;
      let userId = user.UserId;

      let ProductSearch = {
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        ProductCode: this.Product_Code,
        ProductName: this.Product_Name,
        OrgCode: Org_Code,
        LoginUserId: userId,
        TotalCount: 0,
      };

      console.log(ProductSearch);
      return new WebApis.ProductApi()
        .GetProductsPaging(ProductSearch)
        .then((r) => {
          console.log(r);
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
          hideLoading();
        })
        .catch((e) => {
          console.log(e);
          this.$message({
            showClose: true,
            message: e.RspMsg
              ? "获取产品数据异常！" + e.RspMsg
              : "获取产品数据异常！",
            type: "error",
          });
          hideLoading();
        });
    },
    // 点击查询按钮
    onSearch() {
      this.GetProducts();
    },
    clearsearch() {
      this.Product_Code = "";
      this.Product_Name = "";
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.GetProducts();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetProducts();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.GetProducts();
    },
    formatTime(row, column) {
      const date = new Date(row[column.property]);
      return (
        date.getFullYear() +
        "年" +
        date.getMonth() +
        "月" +
        date.getDate() +
        "日"
      );
    },
    onAdd() {
      this.SelectedProductId = "";
      this.isEdit = true;
      this.dilaogconfig.dialogFormVisible = true;
    },
    selectionChange(val) {
      this.multipleSelection = val;
    },
    //产品已维护在组织机构中，不能删除
    canDelete(selectData, callback) {
      let arr = [];
      for (let i = 0; i < selectData.length; i++) {
        new WebApis.OrgProductApi()
          .FindByConditions({
            ProductId: selectData[i].LogicId,
          })
          .then((r) => {
            var data = r.data.Data;
            if (data.length > 0) {
              this.$message.error(
                selectData[i].ProductName + "已维护在组织机构中，不能删除"
              );
              arr.push({ isDelete: false });
            } else {
              arr.push({ isDelete: true });
            }
            callback(arr);
          })
          .catch((e) => {
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    onbatchDel() {
      let Product_Ids = [];
      this.multipleSelection.forEach((item) => {
        Product_Ids.push(item.LogicId);
      });

      if (Product_Ids.length <= 0) {
        this.$message({
          showClose: true,
          message: "请选择要删除的数据!",
          type: "warning",
        });
        return;
      }
      this.$confirm("确定删除选中产品?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let ProductSearch = {
          ProductIds: Product_Ids,
        };
        console.log(ProductSearch);
        const that = this;
        that.canDelete(that.multipleSelection, function (data) {
          const index = data.findIndex((item) => item.isDelete == false);
          if (index == -1 && data.length == Product_Ids.length) {
            new WebApis.ProductApi()
              .DelItemList(ProductSearch)
              .then((r) => {
                if (r.RspCode == "1") {
                  that.$message({ type: "success", message: "删除成功!" });
                  that.GetProducts();
                } else {
                  that.$message({
                    showClose: true,
                    message: r ? "删除失败!" + r.RspMsg : "删除失败!",
                    type: "error",
                  });
                }
                that.logInfo.ActionName = "产品删除";
                that.logInfo.LogMessage =
                  r.RspCode == "1" ? "产品删除成功" : "删除产品失败";
                that.logInfo.ModuleName = "权限管理";
                that.logInfo.PageName = "产品管理列表页面";
                that.addOperationLog();
              })
              .catch((e) => {
                that.$message({
                  showClose: true,
                  message: e.RspMsg
                    ? "删除失败!" + e.RspMsg
                    : "获取产品信息失败!",
                  type: "error",
                });
              });
          } else {
            return;
          }
        });
      });
    },
    queryClick(index, row) {
      this.SelectedProductId = row.LogicId;
      this.isEdit = false;
      this.dilaogconfig.title = "查看产品";
      this.dilaogconfig.dialogFormVisible = true;
    },
    editClick(index, row) {
      this.SelectedProductId = row.LogicId;
      this.isEdit = true;
      this.dilaogconfig.title = "修改产品";
      this.dilaogconfig.dialogFormVisible = true;
    },
    deleteClick(index, row) {
      this.SelectedProductId = row.LogicId;
      this.$confirm("确定删除该产品?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let ProductSearch = {
          ProductId: this.SelectedProductId,
        };
        const that = this;
        that.canDelete([row], function (data) {
          const index = data.findIndex((item) => item.isDelete == false);
          if (index != -1) {
            return;
          } else {
            new WebApis.ProductApi()
              .DelItem(ProductSearch)
              .then((r) => {
                if (r.RspCode == "1") {
                  that.$message({ type: "success", message: "删除成功!" });
                  that.GetProducts();
                } else {
                  that.$message({
                    showClose: true,
                    message: r ? "删除失败!" + r.RspMsg : "删除失败!",
                    type: "error",
                  });
                }
                that.logInfo.ActionName = "产品删除";
                that.logInfo.LogMessage =
                  r.RspCode == "1" ? "产品删除成功" : "删除产品失败";
                that.logInfo.ModuleName = "权限管理";
                that.logInfo.PageName = "产品管理列表页面";
                that.addOperationLog();
              })
              .catch((e) => {
                console.log(e);
                that.$message({
                  showClose: true,
                  message: e.RspMsg
                    ? "删除失败!" + e.RspMsg
                    : "获取产品信息失败!",
                  type: "error",
                });
              });
          }
        });
      });
    },
    handleDialogOk() {
      this.dilaogconfig.dialogFormVisible = false;
      this.GetProducts();
    },
    handleDialogCancel() {
      this.dilaogconfig.dialogFormVisible = false;
    },
  },
};
</script>